import * as types from "../constants/actionTypes";
import initialState from "./initialState";

const autoIdCardsReducer = (state = initialState.autoIdCardsData, action) => {
  switch (action.type) {
    case types.FETCH_AUTO_ID_CARDS_STARTED:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case types.FETCH_AUTO_ID_CARDS_FAILED:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.FETCH_AUTO_ID_CARDS_SUCCEEDED:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
        error: null
      };
    default:
      return state;
  }
};

export default autoIdCardsReducer;
